module.exports = __webpack_public_path__ + "img/appointment.632b62ee.svg";